 /**
 * ON: Sticky bar + flavor selector + tabs controller
 *
 * This is a static asset file — Liquid tags ({{ }}) are NOT processed here.
 * Config (sectionId, currencyCode, etc.) is read at runtime from a
 * <script type="application/json" class="on-sticky-bar-config"> tag that
 * main-product.liquid renders alongside this script, e.g.:
 *
 *   <script src="{{ 'on-sticky-bar.js' | asset_url }}" defer="defer"></script>
 *   <script type="application/json" class="on-sticky-bar-config" data-on-booted="false">
 *     {
 *       "sectionId": {{ section.id | json }},
 *       "currencyCode": {{ shop.currency | json }},
 *       "freeShippingThreshold": 50,
 *       "tierQty": [3, 6],
 *       "tierPct": [0.10, 0.20]
 *     }
 *   </script>
 */
(function () {
  'use strict';

  function boot(config) {
    var sectionId = config.sectionId;

    // ── Translations (window.ON_I18N.stickyBar from main-product.liquid; English fallback) ──
    var I18N = (window.ON_I18N && window.ON_I18N.stickyBar) || {};
    function tr(key, fallback) { return typeof I18N[key] === 'string' ? I18N[key] : fallback; }
    function onFill(str, token, value) { return str.split(token).join(String(value)); }

    // ── Config ────────────────────────────────────────────────
    var FREE_SHIPPING_THRESHOLD = config.freeShippingThreshold || 50;
    var TIER_QTY = config.tierQty || [3, 6];
    var TIER_PCT = config.tierPct || [0.10, 0.20];

    var currencyCode = config.currencyCode || 'USD';
    var locale = document.documentElement.lang || 'en';
    // Fixed shipping fee in store base currency cents (e.g. 999 = $9.99 USD)
    // Combined with Shopify.currency.rate this auto-converts to any local currency
    var SHIPPING_BASE_CENTS = config.shippingBaseCents || 999;

    // ── Hide Subify watermark ────────────────────────────────
    (function hideSubiWatermark() {
      function tryHide() {
        document.querySelectorAll(
          '.subify-powered-text, [class*="subify-powered-text"]'
        ).forEach(function (el) {
          el.style.setProperty('display', 'none', 'important');
        });
      }
      tryHide();
      new MutationObserver(tryHide)
        .observe(document.body, { childList: true, subtree: true });
    })();

    // ── Formatters ────────────────────────────────────────────
    function formatMoney(amount) {
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency', currency: currencyCode, minimumFractionDigits: 2
        }).format(amount);
      } catch (e) {
        return currencyCode + '\u00a0' + amount.toFixed(2);
      }
    }

    function parsePrice(text) {
      if (!text) return 0;
      return parseFloat(text.replace(/[^0-9,\.]/g, '').replace(',', '.')) || 0;
    }

    // ── DOM helpers ───────────────────────────────────────────
    function byId(suffix) {
      return document.getElementById(suffix + '-' + sectionId);
    }

    function getVariantInput() {
      return document.querySelector(
        '#product-form-' + sectionId + ' [name="id"], form[id*="' + sectionId + '"] [name="id"]'
      );
    }

    // ── Read state from DOM ──────────────────────────────────
    function getTotalQty() {
      var total = 0;
      document.querySelectorAll('[class*="SelectedVariantsList_count"]').forEach(function (el) {
        var val = parseInt(el.textContent.trim(), 10);
        if (!isNaN(val)) total += val;
      });
      if (total > 0) return total;

      var qInput = document.querySelector(
        '#product-form-' + sectionId + ' .quantity__input, #Quantity-' + sectionId
      );
      if (qInput) {
        var val = parseInt(qInput.value, 10);
        if (!isNaN(val) && val > 0) return val;
      }
      return 0;
    }

    function isSubscriptionActive() {
      var oneTimeLi = document.querySelector('.subify-selling-plan-col.one-time-purchase');
      if (!oneTimeLi) return false;
      var oneTimeItem = oneTimeLi.querySelector('.subify-selling-plan-item');
      if (oneTimeItem && oneTimeItem.classList.contains('active')) return false;
      return true;
    }

    function getOneTimeUnitPrice() {
      var el = document.querySelector('.subify-original-price.full-price');
      if (el) return parsePrice(el.textContent);

      var input = getVariantInput();
      if (input && window.ON_PRODUCTS && window.ON_PRODUCTS[input.value]) {
        return window.ON_PRODUCTS[input.value].priceOnetime || 0;
      }
      return 0;
    }

    function getSubUnitPrice() {
      var el = document.querySelector('.subify-off-price');
      if (el) return parsePrice(el.textContent);

      var input = getVariantInput();
      if (input && window.ON_PRODUCTS && window.ON_PRODUCTS[input.value]) {
        return window.ON_PRODUCTS[input.value].priceSub || 0;
      }
      return 0;
    }

    // ── Substitute price for Add button on active rows ────────
    function setBundleItemLabel(item, picker, text) {
      var label = null;
      Array.prototype.some.call(item.children, function (child) {
        if (child === picker || (child.contains && child.contains(picker))) return false;
        label = child;
        return true;
      });
      if (label && label.textContent.trim() !== text) {
        label.textContent = text; // overwrite text only (React-safe; no node injection)
      }
    }

    function syncRows() {
      document.querySelectorAll('[class*="SelectedVariantsList_item"]').forEach(function (item) {
        var picker = item.querySelector('[class*="SelectedVariantsList_quantity"]');
        if (!picker) return;
        var row = item.closest('[class*="style_container_7256ce7c"]');
        if (!row) return;
        var priceSpan = row.querySelector('[class*="style_price"]');
        var priceText = priceSpan ? priceSpan.textContent.trim() : '';
        if (priceText) setBundleItemLabel(item, picker, priceText);
      });
    }

    // ── Core calculation ──────────────────────────────────────
    function calcState() {
      var selected = document.querySelector('.on-protocol-card.selected[data-section="' + sectionId + '"]');
      if (!selected) return {};
      
      var titleEl = selected.querySelector('.on-protocol-title');
      var protocolTitle = titleEl ? titleEl.textContent.trim() : 'Selected';

      var finalTotal = parseFloat(selected.dataset.price) / 100;
      var pouches = parseInt(selected.dataset.pouches);
      var days = parseInt(selected.dataset.days);
      var shippingText = selected.dataset.shipping;
      var freeShipUnlocked = selected.dataset.shippingFree
        ? selected.dataset.shippingFree === 'true'
        : (shippingText.toLowerCase() === 'free shipping');
      // Primary: use Shopify.currency.rate (real-time) × fixed USD fee → auto-updates with any market change
      // Fallback: use data-shipping-cost pre-computed in Liquid (proportional from variant.price)
      var exchangeRate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 0;
      var shippingAmount = freeShipUnlocked ? 0
        : exchangeRate > 0 ? (SHIPPING_BASE_CENTS / 100) * exchangeRate
        : parseInt(selected.dataset.shippingCost || '0', 10) / 100;
      var pricePerDayStr = selected.dataset.pricePerDayStr || '';
      var pricePerPouchStr = selected.dataset.pricePerPouchStr || '';

      // Base price is the first item's price
      var basePrice = 0;
      var firstCard = document.querySelector('.on-protocol-card[data-section="' + sectionId + '"]');
      if (firstCard) {
         basePrice = parseFloat(firstCard.dataset.price) / 100;
      }
      
      var multiplier = Math.round(days / 20);
      var originalTotal = basePrice * multiplier;
      var saving = originalTotal - finalTotal;
      if (saving < 0) saving = 0;

      var savingPct = originalTotal > 0 ? Math.round((saving / originalTotal) * 100) : 0;
      var ctaText = tr('addToCart', 'ADD TO CART') + ' \u2192';

      return {
        qty: 1,
        saving: saving,
        savingPct: savingPct,
        finalTotal: finalTotal,
        freeShipThreshold: FREE_SHIPPING_THRESHOLD,
        freeShipRemaining: 0,
        freeShipUnlocked: freeShipUnlocked,
        shippingAmount: shippingAmount,
        shippingText: shippingText,
        pricePerDayStr: pricePerDayStr,
        pricePerPouchStr: pricePerPouchStr,
        protocolTitle: protocolTitle,
        ctaText: ctaText
      };
    }

    // ── Patch FBP tier labels ──────────────────────────────────
    function patchTierLabels() {
      document.querySelectorAll('[class*="styles_option"]').forEach(function (el) {
        el.querySelectorAll('*').forEach(function (child) {
          if (child.children.length === 0 && child.textContent.trim() === 'OFF') {
            child.textContent = onFill(tr('percentOff', '%N%% OFF'), '%N%', 0);
          }
        });
      });
    }

    // ── Render sticky bar ───────────────────────────────────────
    function renderBar(s) {
        s = s || {};
        var saving = s.saving || 0;
        var savingPct = s.savingPct || 0;
        var finalTotal = s.finalTotal || 0;
        var freeShipUnlocked = !!s.freeShipUnlocked;
        var shippingAmount = s.shippingAmount || 0;
        var shippingText = s.shippingText || '';
        var pricePerDayStr = s.pricePerDayStr || '';
        var pricePerPouchStr = s.pricePerPouchStr || '';
        var protocolTitle = s.protocolTitle || 'Base';
        var hasItems = finalTotal > 0;

        function buildShipMsg() {
            if (freeShipUnlocked) {
                return '<strong>' + tr('freeShippingUnlocked', 'Free shipping unlocked!') + '</strong>';
            }
            // "~" prefix + "est." indicates this is an estimate from theme config,
            // not the exact checkout amount (which depends on address & cart).
            var formattedCost = shippingAmount > 0 ? formatMoney(shippingAmount) : shippingText;
            return '<strong>' + onFill(tr('estShipping', '~%P% est. shipping'), '%P%', formattedCost) + '</strong>';
        }

        function buildTierMsg() {
            // Per-pouch only, matching the tier cards. The per-day figure was
            // derived from an assumed four pouches a day, which does not line
            // up with the calendar months the tiers are named for.
            return onFill(tr('perPouch', '%P%/pouch'), '%P%', pricePerPouchStr);
        }

        var els = {
            savingsIcon: byId('on-bar-savings-icon'),
            savingsLabel: byId('on-bar-savings-label'),
            amount: byId('on-bar-savings-amount'),
            pct: byId('on-bar-savings-pct'),
            shipMsg: byId('on-bar-shipping-msg'),
            tierMsg: byId('on-bar-tier-msg'),
            shipFill: byId('on-bar-ship-fill'),
            dTotal: byId('on-bar-total-amount'),
            mTierMsg: byId('on-mobile-tier-msg'),
            mShipMsg: byId('on-mobile-ship-msg'),
            mShipFill: byId('on-mobile-ship-fill'),
            mPrice: byId('on-mobile-total'),
            mSave: byId('on-mobile-you-save'),
            dCta: byId('on-bar-desktop-atc'),
            mCta: byId('on-mobile-atc')
        };

        if (saving > 0) {
            if (els.savingsLabel) els.savingsLabel.textContent = tr('youAreSaving', "You're saving");
            if (els.amount) {
                els.amount.textContent = formatMoney(saving);
                els.amount.style.color = '#4ade80';
            }
            if (els.pct) els.pct.textContent = savingPct > 0 ? onFill(tr('percentOff', '%N%% OFF'), '%N%', savingPct) : '';
            if (els.savingsIcon) {
                els.savingsIcon.style.color = '#4ade80';
                els.savingsIcon.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';
            }
            if (els.mSave) {
                els.mSave.style.display = 'block';
                els.mSave.textContent = onFill(tr('youSave', 'You Save %P%'), '%P%', formatMoney(saving));
            }
        } else {
            if (els.savingsLabel) els.savingsLabel.textContent = tr('pricePerPouchLabel', 'Price per pouch');
            if (els.amount) {
                els.amount.textContent = onFill(tr('perPouch', '%P%/pouch'), '%P%', s.pricePerPouchStr);
                els.amount.style.color = '#ffffff';
            }
            if (els.pct) els.pct.textContent = '';
            if (els.savingsIcon) {
                els.savingsIcon.style.color = '#ffffff';
                els.savingsIcon.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
            }
            if (els.mSave) {
                els.mSave.style.display = 'block';
                els.mSave.textContent = onFill(tr('perPouch', '%P%/pouch'), '%P%', s.pricePerPouchStr);
            }
        }

        [els.shipFill, els.mShipFill].forEach(function (el) {
            if (!el) return;
            el.classList.toggle('is-complete', freeShipUnlocked);
            el.style.width = freeShipUnlocked ? '100%' : '50%';
        });

        if (els.shipMsg) els.shipMsg.innerHTML = buildShipMsg();
        if (els.tierMsg) els.tierMsg.innerHTML = buildTierMsg();
        if (els.mTierMsg) els.mTierMsg.innerHTML = buildTierMsg();
        if (els.mShipMsg) els.mShipMsg.innerHTML = buildShipMsg();
        if (els.mPrice) els.mPrice.textContent = hasItems ? formatMoney(finalTotal) : '\u2014';
        if (els.dTotal) els.dTotal.textContent = hasItems ? formatMoney(finalTotal) : '\u2014';

        var atcLabel = tr('addToCart', 'ADD TO CART');
        var dCta = atcLabel + ' \u2192' + (hasItems ? ' ' + formatMoney(finalTotal) : '');
        var mCta = atcLabel + ' \u2192' + (hasItems ? ' ' + formatMoney(finalTotal) : '');
        if (els.dCta) els.dCta.textContent = dCta;
        if (els.mCta) els.mCta.textContent = mCta;
        // The in-page button carries the same label, from the same place, so
        // the two cannot drift — one is a copy of the other by construction
        // rather than by two people remembering to edit both.
        document.querySelectorAll('.product-form__buttons .on-atc-label').forEach(function (el) {
          if (el.getAttribute('data-on-atc-text') !== atcLabel) el.setAttribute('data-on-atc-text', atcLabel);
          if (el.textContent !== mCta) el.textContent = mCta;
        });
    }

    // ── Recalculate and render ──────────────────────────────────
    // Stock bar follows the selected tier. The percentage is only ever read
    // from the card, which got it from Liquid, which got it from real
    // inventory — nothing here invents or remembers a number. An absent or
    // unparseable value hides the bar rather than defaulting to something,
    // so a tier with no stock data can never inherit its neighbour's figure.
    function syncStockBar() {
      var bar = document.getElementById('on-stock-' + sectionId);
      if (!bar) return;
      var selected = document.querySelector('.on-protocol-card.selected[data-section="' + sectionId + '"]');
      var pct = selected ? parseInt(selected.dataset.stockPct, 10) : NaN;
      if (isNaN(pct) || pct <= 0 || pct > 100) {
        bar.hidden = true;
        return;
      }
      var fill = bar.querySelector('.on-stock__fill');
      var out = bar.querySelector('.on-stock__pct');
      if (fill) fill.style.width = pct + '%';
      if (out) out.textContent = onFill(tr('claimed', '%N%% claimed'), '%N%', pct);
      bar.querySelector('.on-stock__track').setAttribute('aria-label', onFill(tr('claimedAria', '%N%% of this batch claimed'), '%N%', pct));
      bar.hidden = false;
    }

    function refresh() {
      syncRows();
      patchTierLabels();
      syncStockBar();
      renderBar(calcState());
    }

    // ── Flavor selector ─────────────────────────────────────────
    function selectFlavor(variantId) {
      var data = window.ON_PRODUCTS && window.ON_PRODUCTS[variantId];

      document.querySelectorAll('.on-protocol-card[data-section="' + sectionId + '"]').forEach(function (c) {
        c.classList.toggle('selected', c.dataset.sku == variantId);
      });

      var input = getVariantInput();
      if (input) {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var list = byId('on-ingredient-list');
      if (list && data && data.ingredients && data.ingredients.length) {
        list.innerHTML = data.ingredients.map(function (ing) {
          return '<div class="on-ing-row"><div>' +
            '<div class="on-ing-name">' + (ing.name || '') + '</div>' +
            '<div class="on-ing-desc">' + (ing.desc || '') + '</div></div>' +
            '<div class="on-ing-dose">' + (ing.dose || '') + '</div></div>';
        }).join('');
      }

      refresh();
    }

    // ── Tab switcher ────────────────────────────────────────────
    function switchTab(tabId) {
      ['ingredients', 'subscription', 'howto'].forEach(function (id) {
        var panel = byId('on-tab-' + id);
        if (panel) panel.classList.toggle('active', id === tabId);
      });
      document.querySelectorAll('#on-tab-nav-' + sectionId + ' .on-tab-btn').forEach(function (b) {
        b.classList.toggle('active', b.dataset.tab === tabId);
      });
    }

    // ── ATC proxy ──────────────────────────────────────────────
    function proxyAtc() {
      var realAtc =
        document.getElementById('ProductSubmitButton-' + sectionId)
        || document.querySelector('#product-form-' + sectionId + ' [name="add"]')
        || document.querySelector('[id^="ProductSubmitButton-"]')
        || document.querySelector('.product-form__submit');
      if (realAtc) realAtc.click();
      else console.warn('ON: real ATC button not found');
    }

    // ── Init ───────────────────────────────────────────────────
    function init() {
      document.querySelectorAll('.on-protocol-card[data-section="' + sectionId + '"]').forEach(function (card) {
        card.addEventListener('click', function () { selectFlavor(this.dataset.sku); });
      });

      document.querySelectorAll('#on-tab-nav-' + sectionId + ' .on-tab-btn').forEach(function (btn) {
        btn.addEventListener('click', function (e) { e.preventDefault(); switchTab(this.dataset.tab); });
      });

      var dAtc = byId('on-bar-desktop-atc');
      if (dAtc) dAtc.addEventListener('click', proxyAtc);
      var mAtc = byId('on-mobile-atc');
      if (mAtc) mAtc.addEventListener('click', proxyAtc);

      refresh();
      patchTierLabels();
    }

    // ── MutationObserver ─────────────────────────────────────────
    var refreshTimer;
    var stickyBarEl = document.getElementById('on-sticky-bar-' + sectionId);
    var observeTarget = stickyBarEl ? stickyBarEl.closest('.page-width') || document.body : document.body;

    new MutationObserver(function (mutations) {
      var shouldRefresh = false;
      var subifyReplaced = false;
      var syncNow = false;

      mutations.forEach(function (m) {
        if (m.type === 'childList') {
          var nodes = Array.prototype.slice.call(m.addedNodes)
            .concat(Array.prototype.slice.call(m.removedNodes));
          nodes.forEach(function (node) {
            if (node.nodeType === 1 && node.className &&
                typeof node.className === 'string' &&
                node.className.indexOf('subify') !== -1) {
              subifyReplaced = true;
              shouldRefresh = true;
            }
            if (node.nodeType === 1 && (
              (typeof node.className === 'string' && node.className.indexOf('SelectedVariantsList') !== -1) ||
              (node.querySelector && node.querySelector('[class*="SelectedVariantsList"]'))
            )) {
              shouldRefresh = true;
              syncNow = true;
            }
          });
        }

        var t = m.target;
        var isOurs = t.id && (
          t.id.indexOf('on-bar-savings-amount') !== -1 ||
          t.id.indexOf('on-bar-savings-pct') !== -1 ||
          t.id.indexOf('on-bar-savings-icon') !== -1 ||
          t.id.indexOf('on-bar-savings-label') !== -1 ||
          t.id.indexOf('on-bar-shipping-msg') !== -1 ||
          t.id.indexOf('on-bar-ship-fill') !== -1 ||
          t.id.indexOf('on-mobile-pill') !== -1 ||
          t.id.indexOf('on-mobile-ship-msg') !== -1 ||
          t.id.indexOf('on-mobile-ship-fill') !== -1 ||
          t.id.indexOf('on-mobile-total') !== -1 ||
          t.id.indexOf('on-mobile-saving-label') !== -1 ||
          t.id.indexOf('on-mobile-you-save') !== -1 ||
          t.id.indexOf('on-bar-desktop-atc') !== -1 ||
          t.id.indexOf('on-mobile-atc') !== -1
        );
        if (!isOurs) shouldRefresh = true;
      });

      if (syncNow) syncRows();
      if (!shouldRefresh) return;

      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(refresh, subifyReplaced ? 250 : 80);
    }).observe(observeTarget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
      characterData: true
    });

    // ── Bundle update event ───────────────────────────────────────
    document.addEventListener('on:bundle:update', function () {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(refresh, 80);
    });

    // ── Sticky bar visibility ──────────────────────────────────
    function setupStickyBarVisibility() {
      var stickyBar = document.getElementById('on-sticky-bar-' + sectionId);
      if (!stickyBar) {
        return;
      }

      stickyBar.style.opacity = '0';
      stickyBar.style.visibility = 'hidden';
      stickyBar.style.pointerEvents = 'none';

      var isMobile = window.innerWidth < 750;
      stickyBar.style.transform = isMobile
        ? 'translateY(20px)'
        : 'translateX(-50%) translateY(20px)';
      stickyBar.style.transition = 'opacity 0.3s ease, transform 0.3s ease';

      var visible = false;

      function onScroll() {
        var shouldShow = false;
        var isMobile = window.innerWidth < 750;

        // The bar exists to replace the in-page button once that button is no
        // longer reachable. So track the button itself rather than a proxy
        // element and a scroll distance: show the bar only after the button has
        // scrolled off the top of the screen.
        //
        // Note "scrolled past", not merely "not visible" — at the top of the
        // page the button is below the fold and therefore also not visible,
        // and showing a fixed bar there would cover content before the reader
        // has been offered anything to press.
        var cta = document.getElementById('ProductSubmitButton-' + sectionId)
          || document.querySelector('#product-form-' + sectionId + ' [name="add"]')
          || document.querySelector('.product-form__submit');

        if (cta && cta.offsetParent && cta.offsetHeight > 0) {
          shouldShow = cta.getBoundingClientRect().bottom < 0;
        } else {
          // No usable in-page button — fall back to a scroll distance so the
          // bar is still reachable rather than never appearing at all.
          shouldShow = window.scrollY > window.innerHeight * (isMobile ? 0.5 : 0.05);
          if (window.scrollY < window.innerHeight * 0.15) shouldShow = false;
        }

        if (shouldShow && !visible) {
          visible = true;
          stickyBar.style.opacity = '1';
          stickyBar.style.visibility = 'visible';
          stickyBar.style.pointerEvents = 'auto';
          stickyBar.style.transform = isMobile ? 'translateY(0)' : 'translateX(-50%) translateY(0)';
        } else if (!shouldShow && visible) {
          visible = false;
          stickyBar.style.opacity = '0';
          stickyBar.style.visibility = 'hidden';
          stickyBar.style.pointerEvents = 'none';
          stickyBar.style.transform = isMobile ? 'translateY(20px)' : 'translateX(-50%) translateY(20px)';
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        isMobile = window.innerWidth < 750;
      });

      onScroll();
    }

    // ── Boot ─────────────────────────────────────────────────────
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    window.addEventListener('load', function () {
      setupStickyBarVisibility();
      refresh();
      setTimeout(refresh, 300);
      setTimeout(refresh, 800);
      setTimeout(refresh, 1500);
    });
  }

  // ── Multi-instance bootstrap ────────────────────────────────
  function bootAll() {
    document.querySelectorAll('script.on-sticky-bar-config:not([data-on-booted="true"])').forEach(function (node) {
      try {
        var config = JSON.parse(node.textContent);
        node.dataset.onBooted = 'true';
        boot(config);
      } catch (e) {
        console.error('ON sticky bar: invalid config JSON', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();